import DecisionEngine from './DecisionEngine';

function Hero() {
  return (
    <section id="top" className="relative pt-[76px] overflow-hidden">
      <div className="absolute -top-24 right-[-8%] w-[520px] h-[520px] rounded-full bg-accent-200/40 blur-3xl pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[48fr_52fr] gap-12 lg:gap-16 items-center">
          <div className="w-full">
            <div className="inline-flex items-center gap-2 px-3 h-8 rounded-full border border-primary-300 bg-primary-50 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              <span className="text-[11px] font-data tracking-[0.18em] text-primary-700">
                HOW IT WORKS · XAUUSD · MT5
              </span>
            </div>

            <h1 className="font-heading font-extrabold text-foreground-950 tracking-tight text-[36px] leading-[1.06] sm:text-[48px] lg:text-[56px] xl:text-[60px]">
              How The EA Thinks Before It Trades
            </h1>

            <p className="mt-6 font-heading font-semibold text-foreground-700 text-lg md:text-xl max-w-[560px]">
              The system does not treat every price movement as a trading opportunity.
            </p>

            <p className="mt-4 text-[15px] md:text-base leading-relaxed text-foreground-600 max-w-[540px]">
              It ingests live market data, filters it against a fixed rule set and only executes
              through MT5 when the setup passes.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#loop"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[15px] font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer hover:-translate-y-0.5"
              >
                Follow The Flow
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-down-line"></i>
                </span>
              </a>
              <a
                href="#process-numbers"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-foreground-300 text-foreground-950 text-[15px] font-semibold whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-all duration-200 cursor-pointer hover:-translate-y-0.5"
              >
                The Process In Numbers
              </a>
            </div>

            <p className="mt-7 text-[12px] font-data tracking-[0.16em] text-foreground-400">
              A DEFINED SEQUENCE OF CONDITIONS — NOT A BLACK BOX.
            </p>
          </div>

          <div className="w-full">
            <div className="mb-3 flex items-center justify-between">
              <span className="text-[11px] font-data tracking-[0.2em] text-foreground-500">
                FROM INGESTION TO EXECUTION
              </span>
              <span className="text-[11px] font-data tracking-[0.2em] text-foreground-400">
                XAUUSD
              </span>
            </div>
            <DecisionEngine />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;